module.exports = {
  width: 1000,
  height: 700,
  margin: 40,
  theme: require("../themes/default/index"),
  print: require("../themes/default/print"),
  html: require("../themes/default/html")
};



// WEBPACK FOOTER //
// ./~/@jimpick/spectacle/presentation/config.js